module.exports = __webpack_public_path__ + "img/waplogohubble-horizontal.bd0ea612.png";